import Input from 'Components/Atoms/Input/Input';
import { forwardRef, useRef } from 'react';
import { cn } from 'Utils/cn';
import PropTypes from 'prop-types';
import OutlineCalendar from '../OutlineIcons/OutlineCalendar';
import { useMergeRefs } from '@floating-ui/react';
import IconButton from '../IconButton/IconButton';

const DatePicker = forwardRef(function DatePicker(props, ref) {
    const { className, disabled, size, ...rest } = props;
    const inputRef = useRef(null);
    const mergedRef = useMergeRefs([inputRef, ref]);

    const handleOpenCalendar = () => {
        if (inputRef.current) {
            inputRef.current.showPicker();
        }
    };

    return (
        <div className="relative w-full">
            <Input
                type="date"
                className={cn('hide-calendar-picker-indicator', className)}
                ref={mergedRef}
                disabled={disabled}
                size={size}
                {...rest}
            />
            <div className={cn('top-0 right-0 absolute flex items-center h-11', size === 'small' && 'h-8')}>
                <IconButton
                    variant="ghost"
                    disabled={disabled}
                    icon={<OutlineCalendar />}
                    onClick={handleOpenCalendar}
                />
            </div>
        </div>
    );
});

export default DatePicker;

DatePicker.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.string,
    size: PropTypes.oneOf(['normal', 'small']),
};
